<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title>
        <span class="subtitle-1 font-weight-thin"> Service Area Attributes </span>
        <v-spacer></v-spacer>
        <v-btn @click="showCreateForm()" color="primary" data-cy="attributeList__createBtn" outlined small>
          <v-icon class="mr-2" small>fas fa-plus</v-icon>Add New Attribute
        </v-btn>
      </v-card-title>
      <v-checkbox
        :label="`Show ${attributeListDeprecated.length} deprecated attribute(s)`"
        class="ml-3"
        color="primary"
        data-cy="attributeList__checkbox--deprecated"
        id="deprecated-checkbox"
        v-model="showDeprecated"
      ></v-checkbox>

      <v-data-table
        :headers="headerList"
        :hide-default-footer="true"
        :items="attributeListFiltered"
        disable-pagination
        fixed-header
      >
        <template v-slot:item="{ item }">
          <tr>
            <td data-cy="attributeList--item">{{ item.name }}</td>
            <td>
              <div class="text-left">{{ item.isDeprecated ? "deprecated" : "" }}</div>
            </td>
            <td>
              <v-icon small @click="showEditForm(item)" data-cy="attributeList__editBtn">fas fa-edit</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <AdminServiceAreaAttributeForm :attributeList="attributeList" v-model="showForm"></AdminServiceAreaAttributeForm>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AdminServiceAreaAttributeForm from "./AdminServiceAreaAttributeForm";

export default {
  components: {
    AdminServiceAreaAttributeForm,
  },
  computed: {
    attributeList() {
      return this.attributeListByCategory(this.categoryId);
    },
    attributeListFiltered() {
      const { attributeList } = this;
      if (this.showDeprecated) {
        return attributeList.filter(item => !!item.isDeprecated);
      }
      return attributeList.filter(item => !item.isDeprecated);
    },
    attributeListDeprecated() {
      return this.attributeList.filter(item => !!item.isDeprecated);
    },
    ...mapGetters({
      attributeListByCategory: "admin/serviceAreaAttribute/listByCategory",
    }),
  },
  async created() {
    try {
      await this.fetchAttributeList();
    } catch (e) {
      console.error(e);
      this.$notifyError({
        title: "Error",
        message: "Failed to fetch attribute list",
      });
    }
  },
  data() {
    return {
      categoryId: parseInt(this.$route.params.id, 10),
      headerList: [
        {
          text: "Attribute Name",
          value: "name",
        },
        {
          text: "Deprecated",
          value: "isDeprecated",
        },
        {
          value: "actions",
          sortable: false,
        },
      ],
      showDeprecated: false,
      showForm: false,
    };
  },
  methods: {
    showCreateForm() {
      const { categoryId } = this;
      this.setAttributeRecord(Object.assign({}, { categoryId }));
      this.showForm = true;
    },
    showEditForm(serviceAreaAttribute) {
      this.setAttributeRecord(Object.assign({}, serviceAreaAttribute));
      this.showForm = true;
    },
    ...mapActions({
      fetchAttributeList: "admin/serviceAreaAttribute/list",
    }),
    ...mapMutations({
      setAttributeRecord: "admin/serviceAreaAttribute/setRecord",
    }),
  },
};
</script>
